// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ApplyTemplateModalQueryVariables = Types.Exact<{
  filter: Types.ItemTemplateFilter;
}>;


export type ApplyTemplateModalQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, displayName: string }> };

export type ApplyTemplateModalPlanQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
  projectStageId: Types.Scalars['ID']['input'];
}>;


export type ApplyTemplateModalPlanQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, applyTemplatePlan: Array<{ __typename?: 'ItemTemplateItemPlan', itemTemplateItem: { __typename?: 'ItemTemplateItem', id: string }, projectItem?: { __typename?: 'ProjectItem', id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, location: { __typename?: 'Location', id: string, name: string }, costTypeDetail: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } } | null | undefined }> }> };

export type ApplyTemplateItemTemplateFragment = { __typename?: 'ItemTemplate', id: string, displayName: string };

export const ApplyTemplateItemTemplateFragmentDoc = gql`
    fragment ApplyTemplateItemTemplate on ItemTemplate {
  id
  displayName
}
    `;
export const ApplyTemplateModalDocument = gql`
    query ApplyTemplateModal($filter: ItemTemplateFilter!) {
  itemTemplates(filter: $filter) {
    ...ApplyTemplateItemTemplate
  }
}
    ${ApplyTemplateItemTemplateFragmentDoc}`;

/**
 * __useApplyTemplateModalQuery__
 *
 * To run a query within a React component, call `useApplyTemplateModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplateModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useApplyTemplateModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables> & ({ variables: ApplyTemplateModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>(ApplyTemplateModalDocument, options);
      }
export function useApplyTemplateModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>(ApplyTemplateModalDocument, options);
        }
// @ts-ignore
export function useApplyTemplateModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>;
export function useApplyTemplateModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateModalQuery | undefined, ApplyTemplateModalQueryVariables>;
export function useApplyTemplateModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>(ApplyTemplateModalDocument, options);
        }
export type ApplyTemplateModalQueryHookResult = ReturnType<typeof useApplyTemplateModalQuery>;
export type ApplyTemplateModalLazyQueryHookResult = ReturnType<typeof useApplyTemplateModalLazyQuery>;
export type ApplyTemplateModalSuspenseQueryHookResult = ReturnType<typeof useApplyTemplateModalSuspenseQuery>;
export type ApplyTemplateModalQueryResult = Apollo.QueryResult<ApplyTemplateModalQuery, ApplyTemplateModalQueryVariables>;
export const ApplyTemplateModalPlanDocument = gql`
    query ApplyTemplateModalPlan($templateId: ID!, $projectStageId: ID!) {
  itemTemplates(filter: {id: [$templateId]}) {
    id
    applyTemplatePlan(projectStageId: $projectStageId) {
      itemTemplateItem {
        id
      }
      projectItem {
        id
        item {
          id
          fullCode
        }
        name
        location {
          id
          name
        }
        costTypeDetail {
          code
          name
        }
      }
    }
  }
}
    `;

/**
 * __useApplyTemplateModalPlanQuery__
 *
 * To run a query within a React component, call `useApplyTemplateModalPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyTemplateModalPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyTemplateModalPlanQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      projectStageId: // value for 'projectStageId'
 *   },
 * });
 */
export function useApplyTemplateModalPlanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables> & ({ variables: ApplyTemplateModalPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>(ApplyTemplateModalPlanDocument, options);
      }
export function useApplyTemplateModalPlanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>(ApplyTemplateModalPlanDocument, options);
        }
// @ts-ignore
export function useApplyTemplateModalPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>;
export function useApplyTemplateModalPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplyTemplateModalPlanQuery | undefined, ApplyTemplateModalPlanQueryVariables>;
export function useApplyTemplateModalPlanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>(ApplyTemplateModalPlanDocument, options);
        }
export type ApplyTemplateModalPlanQueryHookResult = ReturnType<typeof useApplyTemplateModalPlanQuery>;
export type ApplyTemplateModalPlanLazyQueryHookResult = ReturnType<typeof useApplyTemplateModalPlanLazyQuery>;
export type ApplyTemplateModalPlanSuspenseQueryHookResult = ReturnType<typeof useApplyTemplateModalPlanSuspenseQuery>;
export type ApplyTemplateModalPlanQueryResult = Apollo.QueryResult<ApplyTemplateModalPlanQuery, ApplyTemplateModalPlanQueryVariables>;